//
// Bonus Multiview Bonus Model
// ---------------------------

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseModel = require('common/base.model');
    var server = require('server');
    var user = require('user');
    var config = require('config');
    var bonusMixin = require('mixins/bonus.mixin');

    module.exports = BaseModel.extend({

        mixins: [bonusMixin],

        idAttribute: 'bonusCode',

        defaults: {
            bonusConditions: []
        },

        parse: function(response) {
            var bonusTmpl = response.data.bonusTemplates[0];
            var bonusConfig = bonusTmpl;
            var bonusConditions = bonusConfig.bonusConditions[0];
            var bonusAmounts = bonusConditions.amounts;

            bonusConditions.amounts = _.chain(bonusAmounts)
                .filter(function(amount) {
                    return amount.currencyCode === user.get('currencyCode');
                })
                .sortBy(function(amount) {
                    return Number(amount.fromAmount);
                })
                .map(function(amount) {
                    return _.mapObject(amount, function(val) {
                        return Number(val) ? Number(val) : val;
                    });
                })
                .value();

            bonusConfig.title = this.setBonusName(bonusTmpl);

            return _.omit(bonusConfig, 'type');
        },

        // Get bonus details from IMS
        sync: function(method, model, options) {
            if (method !== 'read') {
                return;
            }

            return this._loadBonusDetails(method, model, options);
        },

        _loadBonusDetails: function(method, model, options) {
            model = model || this;

            return server.send({
                ID: 31079,
                description: 'Get bonuses details',
                responses: [31080, 31081],
                returnGamingContexts: Boolean(options.returnGamingContexts),
                returnWageringCoefficients: false,
                bonusTemplateCodes: [model.get('bonusCode')]
            }).then(options.success, options.error);
        },

        /**
         * Send request to get free bonus
         * @param  {number}  bonusCode
         */
        getFreeBonus: function(bonusCode) {
            return server.send({
                ID: 31065,
                description: 'Get free bonus',
                responses: [31066, 31067],
                triggerType: 'PromotionCode',
                promotionCode: config.get('bonusManagementPreferences.bonusFreeCode'),
                templateCode: bonusCode
            });
        },

        /**
         * Send request to opt-in to bonus
         * @param  {number}  bonusCode
         */
        optIn: function(bonusCode) {
            return server.send({
                ID: 31091,
                description: 'Opt-in',
                responses: [31092, 31093],
                triggerType: 'PromotionCode',
                promotionCode: config.get('bonusManagementPreferences.bonusOptInCode'),
                templateCode: bonusCode
            });
        },

        /**
         * Send request to opt-out from bonus
         * @param  {number}  bonusCode
         */
        optOut: function(bonusCode) {
            return server.send({
                ID: 31094,
                description: 'Opt-out',
                responses: [31095, 31096],
                triggerType: 'PromotionCode',
                promotionCode: 'PORTALOPT',
                templateCode: bonusCode
            });
        }
    });
});
